<template>
  <div class="card">
    <div class="card-body" style="min-height: 22rem">
      <div class="clearfix">
        <div class="d-flex justify-content-between">
          <h4 class="card-title mb-4">Sample Orders for Delivery</h4>
          <div class="float-end">
            <div class="flex-nowrap input-group input-group-sm mb-3">
              <label class="input-group-text bg-light">Date</label>
              <date-picker v-model="ordersDeliveryDateSelected" class="dashboard-datepicker" fixed-position="top-right" @input="ordersDeliveryDateSelectedFn"></date-picker>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-4" />
      <div>
        <data-table :columns="ordersForDeliveryColumns" :rows="sampleOrdersForDeliveryReport.objects" :has-pagination="false" :has-search="false">
          <template v-slot:actions="slotProps" v-if="isToday">
            <div v-if="slotProps.row.availableStatusChanges.length > 0 && checkForPermission(change_order_status_permission)">
              <select :id="slotProps.row.publicId" @change="changeStatus($event, slotProps.row.publicId)" class="dashboard-order-select">
                <option selected></option>
                <option v-for="status in slotProps.row.availableStatusChanges" :value="status.publicId" :key="status.publicId">{{ status.orderStatusName }}</option>
              </select>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {SAMPLE_ORDERS_DUE_FOR_DELIVERY_ON_A_DAY} from "@/gql";
import moment from "moment";
import {permissions} from "@/router/permissions";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
export default {
  name: "SampleOrdersForDelivery",
  components: {DataTable},
  data(){
    return {
      ordersDeliveryDateSelected: new Date(),
      ordersForDeliveryColumns: [
        {
          field: 'sampleOrderTaker.name',
          label: 'Customer'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      sampleOrdersForDeliveryReport: {
        page: 0,
        objects: []
      },
      loading: false,
      deliveryLoading: false,
      currentPage: 1,
      perPage: 30,
      deliveryDates: [moment().format('YYYY-MM-DD')],
      selectedStatus: '',
      change_order_status_permission: permissions.cancel_sample_order_permission,
    }
  },
  apollo: {
    sampleOrdersForDeliveryReport : {
      query: SAMPLE_ORDERS_DUE_FOR_DELIVERY_ON_A_DAY,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          deliveryDates: this.deliveryDates
        }
      }
    }
  },
  computed: {
    isToday(){
      return this.deliveryDates[0] === moment().format('YYYY-MM-DD')
    },
  },
  methods: {
    ... mapActions({
      changeSampleOrderStatus: 'orders/changeSampleOrderStatus',
    }),
    ordersDeliveryDateSelectedFn(){
      this.deliveryDates = [moment(this.ordersDeliveryDateSelected).format('YYYY-MM-DD')]
    },
    async changeStatus(event, sampleOrderId){
      const data = {sampleOrderId: sampleOrderId ,statusId: event.target.value}
      await this.changeSampleOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrdersForDeliveryReport.refetch()
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
